import { connect } from "react-redux";
import { default as component } from "./ContentOrderFilter.jsx";

import {
  isLoading,
  getActiveTab,
  getContentOrdersThatNeedEditing,
  getContentOrdersThatNeedPosting,
  getContentOrdersBeingWritten,
  getRecentlyPublishedContentOrders,
  getFilterName,
} from "../../duck/selectors";

import {
  IN_QUEUE_TAB,
  DEFAULT_TAB,
  EDITED_ORDERS_TAB,
  RECENTLY_COMPLETED_ORDERS_TAB,
} from "../../duck/constants";

import { setFilter, resetFilter } from "../../duck/actions";

const mapStateToProps = (state) => {
  const activeTab = getActiveTab(state);

  let contentOrders;
  switch (activeTab) {
    // Ensure we are providing the full list of results for that section
    case IN_QUEUE_TAB:
      contentOrders = getContentOrdersBeingWritten(state);
      break;
    case EDITED_ORDERS_TAB:
      contentOrders = getContentOrdersThatNeedPosting(state);
      break;
    case RECENTLY_COMPLETED_ORDERS_TAB:
      contentOrders = getRecentlyPublishedContentOrders(state);
      break;
    case DEFAULT_TAB:
      contentOrders = getContentOrdersThatNeedEditing(state);
      break;
  }

  return {
    isLoading: isLoading(state),
    activeTab: activeTab,
    contentOrders,
    filterName: getFilterName(state),
  };
};

const mapDispatchToProps = {
  setFilter,
  resetFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(component);
